import { CalendarDaysIcon, HandRaisedIcon } from "@heroicons/react/24/outline";

function App() {
  return (
    <div className="App bg-[#06181F] min-h-screen w-full">
      <img
        className="absolute top-0 right-0 h-[300px] sm:h-[500px]"
        src={require("../src/assets/images/bg.png")}
        alt=""
      />
      <nav className="py-2 px-4 sm:px-10 sticky z-50 top-3">
        <img
          src={require("../src/assets/images/logo.png")}
          alt="logo"
          className="h-5"
        />
      </nav>
      <section className="top-0 flex justify-center w-full h-full p-6">
        <div className="text-white flex flex-col items-center mt-16 sm:mt-32 max-w-2xl">
          <div className="w-max">
            <p className="head uppercase relative z-30 sm:z-0 leading-[4rem] tracking-wider sm:leading-[7.5rem] text-[3.5rem] sm:text-[6rem] font-extrabold sm:mr-24">
              Finch
            </p>
            <p className="head relative z-30 uppercase leading-[4rem] tracking-wider sm:leading-[7.5rem] text-[3.5rem] sm:text-[6rem] font-extrabold sm:ml-24">
              News
            </p>
          </div>
          <p className="subtext w-full px-4 text-sm sm:text-base mt-12 border-t text-center pt-3 leading-6 sm:pt-6 text-[#8C8C8C] border-[#8C8C8C]">
            Filling you on all things aviation! Keeping you updated and informed
            about what is happening not only in Nigeria but the world at large
          </p>
        </div>
      </section>
      <section className="bg-white min-h-max p-4 pt-12 pb-24 sm:p-10 mt-12">
        <p className="head text-[#FF0000]">INTERNATIONAL NEWS</p>
        <div className="mt-4 grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
          <NewsCard
            text="Malaysia Airlines and MHholidays offers up to 45% off"
            image="bg-news1"
          />
          <NewsCard
            text="COVID IN CHINA:  What’s going on inside 
                  the country and why are others imposing 
                  new travel restrictions"
            image="bg-news2"
          />
          <NewsCard
            text="Etihad creates a new revenue division"
            image="bg-news3"
          />
        </div>
      </section>
      <section className="relative overflow-hidden grid place-items-center min-h-[30vh] p-10">
        <p className="text-2xl leading-[2.5rem] sm:text-4xl sm:leading-[3rem] font-semibold uppercase text-left text-[#1485B0]">
          We believe in <span className="text-white">presence</span>,{" "}
          <span className="text-white">punctuality</span> and{" "}
          <span className="text-white">accountability</span>, as combined, they
          lead to productivity. CULTURE CULTURE
        </p>
        {/* <div className="text-sm font-semibold absolute right-10 uppercase px-6 py-2 text-[#FF0000] bg-[#FF0000]/30 rounded-xl ring-1 ring-inset ring-[#FF0000]">
          Culture
        </div> */}
      </section>
      <section className="bg-[#213740] divide-y divide-[#2A4550] min-h-[60vh]">
        <ArticleCard
          text="How travel agent allegedly defrauded intending hajj pilgrims N24.6m"
          image="bg-article1"
        />
        <ArticleCard
          left
          text="Despite many checkpoints in Seme route, many still travel in, out of Nigeria illegally"
        />
        <ArticleCard
          text="African airlines record 90.5 % surge amid global passenger recovery"
          image="bg-article2"
          top
        />
      </section>
      <section className="sm:p-2 min-h-[70vh] overflow-hidden sm:grid sm:place-items-center">
        <div className="relative isolate bg-transparent py-16 sm:py-24 lg:py-32">
          <div className="mx-auto px-8 sm:max-w-7xl w-full">
            <div className="mx-auto grid place-items-center max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
              <div className="max-w-xl lg:max-w-lg">
                <h2 className="head font- text-white sm:text-4xl">
                  Subscribe to our Newsletter.
                </h2>
                <p className="mt-4 text-sm max-w-lg leading-7 text-wrap text-gray-300">
                  Stay updated with the latest news, exclusive offers, and
                  insights delivered straight to your inbox. Join our community
                  today!
                </p>
                <div className="mt-6 flex max-w-md gap-x-4">
                  <label htmlFor="email-address" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset outline-none outline-0 ring-white/10 text-xs sm:text-sm sm:leading-6"
                    placeholder="Enter your email"
                  />
                  <button
                    type="submit"
                    className="flex-none rounded-md bg-[#FF0000] px-3.5 py-2.5 sm:text-sm text-xs font-semibold text-white shadow-sm hover:bg-[#EA0808] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                  >
                    Subscribe
                  </button>
                </div>
              </div>
              <dl className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2">
                <div className="flex flex-col bg-white/5 p-6 rounded-2xl ring-1 ring-inset ring-white/10 items-start">
                  <div className="rounded-md bg-white/5 p-1 sm:p-2 ring-1 ring-white/10">
                    <CalendarDaysIcon
                      className="size-5 sm:size-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  <dt className="mt-5 font-semibold text-white">
                    Weekly articles
                  </dt>
                  <dd className="mt-1 leading-[1.75rem] text-sm text-gray-400">
                    Stay updated with our curated selection of insightful
                    articles every week. Dive into a diverse range of topics to
                    keep you informed and inspired.
                  </dd>
                </div>
                <div className="flex flex-col bg-white/5 p-6 rounded-2xl ring-1 ring-inset ring-white/10 items-start">
                  <div className="rounded-md bg-white/5 p-1 sm:p-2 ring-1 ring-white/10">
                    <HandRaisedIcon
                      className="size-5 sm:size-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  <dt className="mt-5 font-semibold text-white">No spam</dt>
                  <dd className="mt-1 leading-[1.75rem] text-sm text-gray-400">
                    Stay informed with our latest updates, worry-free. We
                    promise no spam, only valuable content straight to your
                    inbox.
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <div
            className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6"
            aria-hidden="true"
          >
            <div
              className="aspect-[1155/678] w-[60rem] bg-gradient-to-tr from-[#1485B0] to-[#F4851F] opacity-30"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
        </div>
      </section>
      <footer className="bg-[#013548] p-8  flex flex-wrap gap-4 sm:gap-2 justify-center sm:justify-between items-center">
        <a
          href="mailto:i@f.com"
          className="text-sm font-medium text-gray-400 hover:text-white"
        >
          corporatecomms@finchglowholdings.com
        </a>
        <div className="flex items-center gap-3 text-[#013548]">
          <div className="social-link group">
            <i className="fa-brands fa-instagram group-hover:!text-white"></i>
          </div>
          <div className="social-link group">
            <i className="fa-brands fa-facebook-f group-hover:!text-white"></i>
          </div>
          <div className="social-link group">
            <i className="fa-brands fa-x-twitter group-hover:!text-white"></i>
          </div>
          <div className="social-link group">
            <i className="fa-brands fa-linkedin-in group-hover:!text-white"></i>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

const NewsCard = ({ text, image }: { text: string; image: string }) => {
  return (
    <div className="group hover:bg-neutral-50 bg-neutral-50 sm:bg-transparent ring-1 hover:ring-1 sm:ring-0 ring-neutral-100 ring-inset rounded-lg cursor-pointer p-3">
      <div
        className={`${image} shadow-xl bg-cover bg-center rounded-lg h-[150px] sm:h-[250px]`}
      ></div>
      <p className="text-sm font-semibold mt-5 group-hover:underline line-clamp-2">
        {text}
      </p>
      <p className="text-[10px] font-medium px-3 py-2 rounded-md mt-4 w-max bg-[#FE4B4B] ring-1 ring-[#FE4B4B] ring-inset text-white hover:bg-white hover:text-[#FE4B4B]">
        Read Article
      </p>
    </div>
  );
};

const ArticleCard = ({
  left,
  text,
  image,
  top,
}: {
  left?: boolean;
  text: string;
  image?: string;
  top?: boolean;
}) => {
  return (
    <div className="grid grid-cols-6 place-items-center sm:place-items-start group px-2 py-2 sm:px-10 sm:py-10 hover:bg-[#2A4550]/60 cursor-pointer article">
      <div
        className={`${image != null ? image : "bg-news1"} col-span-2 ${
          top ? "bg-top" : "bg-center"
        }  bg-cover rounded-md p-4 h-[100px] sm:h-[240px] w-full`}
      ></div>
      <div
        className={`col-span-4 ${
          left && "order-first"
        } overflow-hidden sm:px-10 px-4 w-full h-full py-4 sm:py-8 group-hover:*:text-white relative`}
      >
        <div className="sm:text-xs text-[10px] uppercase w-max px-4 sm:px-6 py-1 sm:py-2 font-semibold !text-[#FFE600] bg-[#FFE600]/30 rounded-full sm:rounded-2xl ring-1 ring-inset ring-[#FFE600]">
          Local news
        </div>
        <p className="text-gray-300 mt-3 article-title sm:text-base text-xs">
          {text}
        </p>
        <p
          className={`${
            left ? "text-left left-10" : "sm:text-right right-10"
          } sm:absolute mt-3 bottom-6 cursor-pointer hover:text-neutral-200 w-full text-xs underline text-neutral-400`}
        >
          Read More
        </p>
      </div>
    </div>
  );
};

// https://images.unsplash.com/photo-1589209934789-4aacd30e8e3d
// https://images.unsplash.com/photo-1537511446984-935f663eb1f4
